export function isDark(theme) {
  return theme === "dark";
}
